import React, {useCallback, useMemo} from "react";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {CenterBox} from "@pg-design/grid-module";
import {flexAbsoluteCenter, flexDirection, mb, onDesktop, position, textAlign, w100} from "@pg-design/helpers-css";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";
import {useIsMobile, useIsMounted} from "@pg-mono/hooks";
import {convertToArrayOfLatLngLiterals, convertToLatLngLiteral, IMarker, IPolygon, LazyOpenStreetMap} from "@pg-mono/open-street-map";

import {IRPStore} from "../../../../app/rp_reducer";
import {createOfferLink} from "../../../../offer/helpers/create_offer_link";
import {getOfferTypeNamePluralWhat} from "../../../../offer/helpers/OfferType";
import {getOfferMarkerIcon} from "../../../../offer/list/components/OfferListMap/getOfferMarkerIcon";
import {IOfferListOffer} from "../../../../offer/types/IOfferListOffer";
import {IRegionReportPrice} from "../../../../region/types/IRegionReportPrice";
import {pricesReportAnalytics, PricesReportGTMViewAction} from "../../utils/prices_report_analytics";
import {PricesMarkerPopup} from "./PricesMarkerPopup";

interface IProps {
    region: IRegionReportPrice;
    offers: IOfferListOffer[];
}

export const PricesMapCity = (props: IProps) => {
    const isMobile = useIsMobile();
    const isMounted = useIsMounted();
    const favouriteOffers = useSelector((state: IRPStore) => state.favourite.favourites.offers);
    const appliedOffers = useSelector((state: IRPStore) => state.offerListMap.appliedOffers.data);

    const markers = useMemo(() => {
        return props.offers.map((offer) => {
            const isFavourite = favouriteOffers.includes(offer.id);
            const hasBeenApplicationSent = appliedOffers.includes(offer.id);

            return {
                id: offer.id,
                coords: convertToLatLngLiteral(offer.geo_point.coordinates, {reversedValues: true}),
                onClick: () => {
                    pricesReportAnalytics.gtm.viewEvent(PricesReportGTMViewAction.INVEST_MAP_CLICK);
                },
                popup: () => (
                    <PricesMarkerPopup
                        offer={offer}
                        vendor={offer.vendor}
                        text={`liczba ${getOfferTypeNamePluralWhat(offer.type)}: ${offer.stats?.properties_count_for_sale ?? 0}`}
                    />
                ),
                icon: {
                    url: getOfferMarkerIcon(isFavourite, !!hasBeenApplicationSent),
                    sizes: [16, 16]
                }
            } as IMarker;
        });
    }, [props.offers]);

    const polygons = useMemo(() => {
        let polygons: IPolygon[] | undefined = [];
        if (props.region) {
            polygons.push({
                id: props.region.short_name,
                positions: convertToArrayOfLatLngLiterals(props.region.area.geo_area.coordinates, {reversedValues: true}),
                color: "#ff0000",
                opacity: 0.5,
                fillOpacity: 0.02
            });
        } else {
            polygons = undefined;
        }
        return polygons;
    }, []);

    // map will flicker without useCallback
    const onMarkerClick = useCallback((id: number, offers: IOfferListOffer[]) => {
        const offer = offers.find((offer) => offer.id === id);
        if (window && offer) {
            const link = createOfferLink(offer);
            window.open(link);
        }
    }, []);

    return (
        <div css={[flexAbsoluteCenter, flexDirection("column")]}>
            <Text variant="headline_2" css={[mb(3), textAlign("center")]}>
                Mapa nowych inwestycji {props.region.name_declension_where}
            </Text>

            {!!props.offers ? (
                <div css={mapHolder}>
                    {isMounted ? (
                        <LazyOpenStreetMap
                            markers={markers}
                            polygons={polygons}
                            onMarkerClick={
                                isMobile
                                    ? undefined
                                    : (params) => {
                                          onMarkerClick(params.marker.id as number, props.offers);
                                      }
                            }
                        />
                    ) : (
                        <CenterBox>
                            <Loader size="lg" />
                        </CenterBox>
                    )}
                </div>
            ) : (
                <Text variant="headline_4" as="p" css={mb(3)}>
                    Wystąpił problem przy ładowaniu mapy. Spróbuj ponownie później.
                </Text>
            )}
        </div>
    );
};

const mapHolder = css`
    ${flexAbsoluteCenter};
    ${mb(3)};
    ${position("relative")};
    ${w100};
    min-height: 450px;

    ${onDesktop(css`
        min-height: 880px;
    `)};
`;
import React, {useCallback, useMemo} from "react";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {CenterBox} from "@pg-design/grid-module";
import {flexAbsoluteCenter, flexDirection, mb, onDesktop, position, textAlign, w100} from "@pg-design/helpers-css";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";
import {useIsMobile, useIsMounted} from "@pg-mono/hooks";
import {convertToArrayOfLatLngLiterals, convertToLatLngLiteral, IMarker, IPolygon, LazyOpenStreetMap} from "@pg-mono/open-street-map";

import {IRPStore} from "../../../../app/rp_reducer";
import {createOfferLink} from "../../../../offer/helpers/create_offer_link";
import {getOfferTypeNamePluralWhat} from "../../../../offer/helpers/OfferType";
import {getOfferMarkerIcon} from "../../../../offer/list/components/OfferListMap/getOfferMarkerIcon";
import {IOfferListOffer} from "../../../../offer/types/IOfferListOffer";
import {IRegionReportPrice} from "../../../../region/types/IRegionReportPrice";
import {pricesReportAnalytics, PricesReportGTMViewAction} from "../../utils/prices_report_analytics";
import {PricesMarkerPopup} from "./PricesMarkerPopup";

interface IProps {
    region: IRegionReportPrice;
    offers: IOfferListOffer[];
}

export const PricesMapCity = (props: IProps) => {
    const isMobile = useIsMobile();
    const isMounted = useIsMounted();
    const favouriteOffers = useSelector((state: IRPStore) => state.favourite.favourites.offers);
    const appliedOffers = useSelector((state: IRPStore) => state.offerListMap.appliedOffers.data);

    const markers = useMemo(() => {
        return props.offers.map((offer) => {
            const isFavourite = favouriteOffers.includes(offer.id);
            const hasBeenApplicationSent = appliedOffers.includes(offer.id);

            return {
                id: offer.id,
                coords: convertToLatLngLiteral(offer.geo_point.coordinates, {reversedValues: true}),
                onClick: () => {
                    pricesReportAnalytics.gtm.viewEvent(PricesReportGTMViewAction.INVEST_MAP_CLICK);
                },
                popup: () => (
                    <PricesMarkerPopup
                        offer={offer}
                        vendor={offer.vendor}
                        text={`liczba ${getOfferTypeNamePluralWhat(offer.type)}: ${offer.stats?.properties_count_for_sale ?? 0}`}
                    />
                ),
                icon: {
                    url: getOfferMarkerIcon(isFavourite, !!hasBeenApplicationSent),
                    sizes: [16, 16]
                }
            } as IMarker;
        });
    }, [props.offers]);

    const polygons = useMemo(() => {
        let polygons: IPolygon[] | undefined = [];
        if (props.region) {
            polygons.push({
                id: props.region.short_name,
                positions: convertToArrayOfLatLngLiterals(props.region.area.geo_area.coordinates, {reversedValues: true}),
                color: "#ff0000",
                opacity: 0.5,
                fillOpacity: 0.02
            });
        } else {
            polygons = undefined;
        }
        return polygons;
    }, []);

    // map will flicker without useCallback
    const onMarkerClick = useCallback((id: number, offers: IOfferListOffer[]) => {
        const offer = offers.find((offer) => offer.id === id);
        if (window && offer) {
            const link = createOfferLink(offer);
            window.open(link);
        }
    }, []);

    return (
        <div css={[flexAbsoluteCenter, flexDirection("column")]}>
            <Text variant="headline_2" css={[mb(3), textAlign("center")]}>
                Mapa nowych inwestycji {props.region.name_declension_where}
            </Text>

            {!!props.offers ? (
                <div css={mapHolder}>
                    {isMounted ? (
                        <LazyOpenStreetMap
                            markers={markers}
                            polygons={polygons}
                            onMarkerClick={
                                isMobile
                                    ? undefined
                                    : (params) => {
                                          onMarkerClick(params.marker.id as number, props.offers);
                                      }
                            }
                        />
                    ) : (
                        <CenterBox>
                            <Loader size="lg" />
                        </CenterBox>
                    )}
                </div>
            ) : (
                <Text variant="headline_4" as="p" css={mb(3)}>
                    Wystąpił problem przy ładowaniu mapy. Spróbuj ponownie później.
                </Text>
            )}
        </div>
    );
};

const mapHolder = css`
    ${flexAbsoluteCenter};
    ${mb(3)};
    ${position("relative")};
    ${w100};
    min-height: 450px;

    ${onDesktop(css`
        min-height: 880px;
    `)};
`;
